module.exports = __webpack_public_path__ + "static/media/49.673f4945.jpg";